import { render, staticRenderFns } from "./managesecset.vue?vue&type=template&id=22f7e2b5"
import script from "./managesecset.vue?vue&type=script&lang=js"
export * from "./managesecset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports